export default {
    'Placeholder': 'Platzhalter',
}